export default {
    'Placeholder': 'Platzhalter',
}